import React, { useState, useEffect } from "react";

// Portrait viewports (phones) get the portrait crop; everything else the
// landscape photo. Resolved in JS so it updates when the device rotates
// (CRA can't resolve a public/ asset referenced from a CSS url()).
const PORTRAIT_QUERY = "(orientation: portrait)";

function pickBackground() {
  const base = process.env.PUBLIC_URL || "";
  const portrait = window.matchMedia(PORTRAIT_QUERY).matches;
  return base + (portrait ? "/landing-bg-portrait.jpg" : "/landing-bg.jpg");
}

function App() {
  const [bg, setBg] = useState(pickBackground);

  useEffect(() => {
    const mql = window.matchMedia(PORTRAIT_QUERY);
    const update = () => setBg(pickBackground());
    mql.addEventListener("change", update);
    return () => mql.removeEventListener("change", update);
  }, []);

  return (
    <main className="landing" style={{ backgroundImage: `url(${bg})` }}>
      <div className="landing-overlay">
        <h1 className="landing-title">Intelligent Public</h1>
        <p className="landing-body">
          is a US-incorporated nonprofit organization (501(c)(3)) whose mission is
          to leverage advanced technologies for the betterment of society.
        </p>
        <p className="landing-body">
          Our initial, flagship project is called{" "}
          <a className="landing-link" href="https://brightgov.org">
            BrightGov
          </a>
          .
        </p>
      </div>
      <footer className="landing-footer">
        <div>© 2026, Intelligent Public. All rights reserved.</div>
        <div>
          Federal EIN 33-1674842. Registered with the CA Secretary of State and
          Registry of Charities.
        </div>
      </footer>
    </main>
  );
}

export default App;
